import { Injectable } from "@angular/core";
import { FetchStatusSelector } from "@obg/ngrx-utils";
import { JurisdictionSelector } from "@obg/ngx.core";

import { GamingExternalState } from "../state";

import { ACTION_PREFIX } from "./game-variant.action";
import { BaseProviderParams, GameSettings, GameVariantDetail } from "./game-variant.model";

@Injectable({
	providedIn: "root",
})
export class GameVariantSelector {
	get(gameVariantId: string) {
		return (state: GamingExternalState): GameVariantDetail<BaseProviderParams> => {
			const id = `${JurisdictionSelector.get(state)}-${gameVariantId}`;

			// todo: API should handle this inconsistency. Some gameVariants are not jurisdiction specific.
			return (
				state.gamingExternal.gameVariant.gameVariants[id] ||
				state.gamingExternal.gameVariant.gameVariants[gameVariantId]
			);
		};
	}

	getSettings(gameId: string) {
		return (state: GamingExternalState): GameSettings => state.gamingExternal.gameVariant.gameSettings[gameId];
	}

	isBusy() {
		return (state: GamingExternalState): boolean => FetchStatusSelector.isBusy(ACTION_PREFIX)(state);
	}
}
